<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Aftrekbaar bedrag aan lijfrentepremies
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Je mag alleen een bedrag aftrekken als je een pensioentekort hebt. Wij berekenen dit op basis van de
                gegevens die je invult. Je hebt een tekort als je per jaar minder pensioen opbouwt dan nodig is om een
                oudedagsvoorziening (inclusief AOW) te krijgen. Je kunt ook een tekort in je pensioenopbouw hebben,
                terwijl je in loondienst pensioen opbouwt. Heb je een pensioentekort? Dan hebt je 'ruimte' om een bedrag
                af te trekken.
                <div class="space10"></div>

                Je mag je lijfrentepremie aftrekken van de belasting omdat je deze gebruikt om het tekort in je
                pensioenopbouw aan te vullen. Je jaarruimte en je reserveringsruimte bepalen de maximale hoogte van je
                aftrek. Als je op 1 januari de AOW-leeftijd hebt bereikt, dan heb je geen jaarruimte meer.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Jaarruimte
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Je hebt jaarruimte als je in het jaar ervoor niet voldoende pensioen hebt opgebouwd. De jaarruimte in
                {{ this.year }} hangt dus af van je situatie in {{ this.year - 1 }}. Heb over {{ this.year - 1 }} een
                tekort in je pensioenopbouw en bereik je nog niet de leeftijd die 5 jaar hoger is dan de AOW-leeftijd?
                Dan heb je meestal jaarruimte in {{ this.year }}.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Reserveringsruimte
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Hebt je je jaarruimte in {{ this.year - 10 }} tot en met {{ this.year - 1 }} niet helemaal gebruikt?
                Bijvoorbeeld omdat je in deze periode geen lijfrentepremies hebt betaald? Dan mag je deze
                in {{ this.year }} nog gebruiken. Wij noemen dit reserveringsruimte.
                <div class="space10"></div>

                De reserveringsruimte is de optelsom van de jaarruimten in de jaren {{ this.year - 10 }} tot en
                met {{ this.year - 1 }} die je niet, of niet volledig, hebt gebruikt. Had je van {{ this.year - 10 }}
                tot en met {{ this.year - 1 }} in 1 of meer jaren wel jaarruimte? Maar heb je toen lagere bedragen voor
                lijfrente gestort dan het bedrag dat je mocht aftrekken? Of heb je toen niet het maximale bedrag
                afgetrokken? Dan kun je alsnog in {{ this.year }} het totaal van de jaarruimten {{ this.year - 10 }} tot
                en met {{ this.year - 1 }} die je niet, of niet volledig hebt gebruikt, aftrekken. Deze totale
                jaarruimte geldt voor je uitgaven voor lijfrenten en stortingen op een bancaire lijfrente.
                <div class="space10"></div>

                De opgebouwde reserveringsruimte is in {{ this.year }} maximaal
                € {{ this.maxReserveringsruimte | number:'1.0-0' }}.
                <div class="space10"></div>

                <b>Kun je niet alle premies of stortingen aftrekken?</b><br/>
                Kun je de in een jaar betaalde premies of stortingen voor een lijfrente niet (helemaal) aftrekken?
                Bijvoorbeeld omdat de jaarruimte te laag is? Dan wordt bij het berekenen van de belasting die je moet
                betalen als de uitkeringen ingaan, rekening gehouden met deze niet-afgetrokken premies of stortingen. Je
                betaalt dan alleen belasting over de uitkeringen of afkoopsom als dat bedrag hoger is dan het bedrag van
                de niet-afgetrokken premies of stortingen. Dat geldt echter niet onbeperkt. Kijk voor meer informatie
                onderstaand bij 'Meer fiscale informatie'.


            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                In te vullen gegevens
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Voor het berekenen van de jaar- en reserveringsruimte dien je gegevens van het voorgaande jaar in te
                vullen. <br/>
                Voorbeeld: <br/>
                - voor de jaarruimte 2024 vul je de gegevens in uit het jaar 2023<br/>
                - voor de reserveringsruimte 2018 vul je de gegevens in uit het jaar 2017.<br/>
                <br/>
                <li>
                    <b>Winst</b><br/>
                    Het gaat bij 'winst' om de winst vóór de ondernemersaftrek en mkb-winstvrijstelling.
                </li>
                <li>
                    <b>Toe-/Afname FOR</b><br/>
                    Is er als ondernemer winst gereserveerd voor de fiscale oudedagsreserve (FOR)? Of is er sprake van
                    een vrijval van de FOR? Dan neem je dit bedrag mee in de berekening. Nb. Sinds 1 januari 2023 kan je
                    geen gebruik meer maken van de FOR.
                </li>
                <li>
                    <b>Loon</b><br/>
                    Hierbij gaat het om het totaalbedrag van de inkomsten uit loondienst in Nederland. Fooien tellen
                    mee, net als de aftrek reiskosten openbaar vervoer. Ook inkomsten uit loondienst in het buitenland
                    en buitenlands pensioen en uitkeringen tellen mee.
                </li>
                <li>
                    <b>Factor A</b><br/>
                    Hier gaat het om de pensioenaangroei. Deze vind je op de laatste pagina van het 'Uniform
                    pensioenoverzicht' die men jaarlijks van de =pensioenuitvoerder ontvangt. Als er in één jaar
                    meerdere pensioenuitvoerders zijn, tel je voor beide de factor A bij elkaar op. De factor A geldt
                    alleen als er (ooit) pensioen is opgebouwd via een werkgever. Is belastingplichtige een ondernemer
                    en heb is geen pensioen opgebouwd? Dan is de factor A € 0.
                </li>
                <li>
                    <b>ROW/TBS</b><br/>
                    Het gaat hier om de inkomsten uit overig werk (resultaat overige werkzaamheden/row) en de inkomsten
                    uit terbeschikkinggesteld vermogen (tbs).
                </li>
                <li>
                    <b>Uitkeringen</b><br/>
                    Neem het totaalbedrag over van de aangifte bij ‘AOW, pensioen, lijfrente en andere uitkeringen en
                    afkoopsommen die onder de loonheffing vielen. Tel hier ook periodieke uitkeringen en ontvangen
                    alimentatie mee.
                </li>
                <li>
                    <b>Netto pensioen</b><br/>
                    Een netto-pensioen is een vrijwillige pensioenspaarmogelijkheid als je meer verdient dan een bepaald
                    salaris. Met deze regeling kun je pensioen opbouwen over dat salaris. De pensioenpremie die je
                    betaalt voor een netto-pensioen is niet aftrekbaar van het inkomen.
                    <br/>
                    Is er in een jaar gebruikgemaakt van deze vrijwillige pensioenspaarmogelijkheid? Dan vul je hier de
                    premie in die er in dat jaar is betaald over het deel van een inkomen boven een bepaald bedrag
                    (verschilt per jaar). Dat is dam het bedrag voor de netto-pensioenregeling. Het staat op het
                    overzicht van het pensioenfonds.
                </li>
                <li>
                    <b>Benutte ruimte</b><br/>
                    Vul hier het totaalbedrag in van de lijfrentepremies die in dat jaar binnen de jaarruimte zijn
                    afgetrokken. Tel ook de premies mee die er al in de reserveringsruimte van jaren daarna zijn
                    afgetrokken vanwege niet-benutte jaarruimte in dat eerdere jaar.
                </li>

            </div>
        </div>
    </div>


</div>

